module.exports = {
  title: 'Checkbox Interactions with Reanimated',
  author: 'Enzo Manuel Mangano',
  date: '2024-07-03',
  slug: 'checkbox-interactions',
  tags: ['reanimated'],
};
